import { render, staticRenderFns } from "./attachment-card.vue?vue&type=template&id=26575192&scoped=true&"
import script from "./attachment-card.vue?vue&type=script&lang=ts&"
export * from "./attachment-card.vue?vue&type=script&lang=ts&"
import style0 from "./attachment-card.vue?vue&type=style&index=0&id=26575192&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26575192",
  null
  
)

export default component.exports